import root from './_root.js';

/** Built-in value references. */
var Symbol = root.Symbol;

export default Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/report-components/~/lodash-es/_Symbol.js
// module id = 81
// module chunks = 4